/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-service-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleCreate = `${prefix}.modalTitleCreate`;
export const groupsLoadBalancingAlgorithmDropdownLabel = `${prefix}.groupsLoadBalancingAlgorithmDropdownLabel`;
export const enableGslbServiceCheckboxLabel = `${prefix}.enableGslbServiceCheckboxLabel`;
export const topologyPolicyEnabledCheckboxLabel = `${prefix}.topologyPolicyEnabledCheckboxLabel`;
export const resolveCnameCheckboxLabel = `${prefix}.resolveCnameCheckboxLabel`;
export const wildcardMatchCheckboxLabel = `${prefix}.wildcardMatchCheckboxLabel`;
export const ednsClientSubnetCheckboxLabel = `${prefix}.ednsClientSubnetCheckboxLabel`;
export const sitePersistenceEnabledCheckboxLabel = `${prefix}.sitePersistenceEnabledCheckboxLabel`;
export const persistenceProfileDropdownPlaceholder = `${prefix}.persistenceProfileDropdownPlaceholder`;
export const persistenceProfileDropdownLabel = `${prefix}.persistenceProfileDropdownLabel`;
export const ipsReturnedByDnsInputLabel = `${prefix}.ipsReturnedByDnsInputLabel`;
export const ttlServedByDnsServiceInputLabel = `${prefix}.ttlServedByDnsServiceInputLabel`;
export const defaultDnsServiceInputPlaceholder = `${prefix}.defaultDnsServiceInputPlaceholder`;
export const minimumServersInputLabel = `${prefix}.minimumServersInputLabel`;
export const minimumServersInputPlaceholder = `${prefix}.minimumServersInputPlaceholder`;
export const healthMonitorScopeInputLabel = `${prefix}.healthMonitorScopeInputLabel`;
export const downResponseTypeInputLabel = `${prefix}.downResponseTypeInputLabel`;
export const fallbackIpInputLabel = `${prefix}.fallbackIpInputLabel`;
export const fallbackIpInputPlaceholder = `${prefix}.fallbackIpInputPlaceholder`;
export const domainSectionHeader = `${prefix}.domainSectionHeader`;
export const poolSectionHeader = `${prefix}.poolSectionHeader`;
export const gslbServiceRecordTypeLabel = `${prefix}.gslbServiceRecordTypeLabel`;
export const includeAdditionalRecordsLabel = `${prefix}.includeAdditionalRecordsLabel`;
export const publicIpv4AddressInputLabel = `${prefix}.publicIpv4AddressInputLabel`;
export const publicIpv4AddressPlaceholderLabel = `${prefix}.publicIpv4AddressPlaceholderLabel`;
export const publicIpv6AddressInputLabel = `${prefix}.publicIpv6AddressInputLabel`;
export const publicIpv6AddressPlaceholderLabel = `${prefix}.publicIpv6AddressPlaceholderLabel`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit GSLB Service',
    [modalTitleCreate]: 'Create GSLB Service',
    [groupsLoadBalancingAlgorithmDropdownLabel]: 'Groups Load Balancing Algorithm',
    [enableGslbServiceCheckboxLabel]: 'Enable GSLB Service',
    [topologyPolicyEnabledCheckboxLabel]: 'Topology Policy',
    [resolveCnameCheckboxLabel]: 'Resolve CNAME',
    [wildcardMatchCheckboxLabel]: 'Wildcard Match',
    [ednsClientSubnetCheckboxLabel]: 'EDNS Client Subnet',
    [sitePersistenceEnabledCheckboxLabel]: 'Site Persistence',
    [persistenceProfileDropdownPlaceholder]: 'Select Persistence Profile',
    [persistenceProfileDropdownLabel]: 'Site Cookie Application Persistence Profile',
    [ipsReturnedByDnsInputLabel]: 'Number of IPs returned by DNS Server',
    [ttlServedByDnsServiceInputLabel]: 'TTL served by DNS Service',
    [defaultDnsServiceInputPlaceholder]: 'Default from DNS Service',
    [minimumServersInputLabel]: 'Minimum number of Servers',
    [minimumServersInputPlaceholder]: 'Enter Minimum number of servers',
    [healthMonitorScopeInputLabel]: 'Health Monitor Scope',
    [downResponseTypeInputLabel]: 'Down Response',
    [fallbackIpInputLabel]: 'Fallback IP',
    [fallbackIpInputPlaceholder]: 'Enter IP(0.0.0.0)',
    [domainSectionHeader]: 'Domain',
    [poolSectionHeader]: 'GSLB Pool',
    [gslbServiceRecordTypeLabel]: 'GSLB Service Record Type',
    [includeAdditionalRecordsLabel]: 'Include Additional Records',
    [publicIpv4AddressInputLabel]: 'Public IPv4 Address',
    [publicIpv4AddressPlaceholderLabel]: 'Enter Public IPv4 Address',
    [publicIpv6AddressInputLabel]: 'Public IPv6 Address',
    [publicIpv6AddressPlaceholderLabel]: 'Enter Public IPv6 Address',
};
